var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditFullWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59503 18.3589L16.6492 7.94332C17.0869 7.38165 17.2426 6.73227 17.0967 6.07107C16.9702 5.46999 16.6006 4.89846 16.0461 4.46489L14.694 3.39081C13.517 2.45469 12.0579 2.55323 11.2214 3.6273L10.3168 4.8009C10.2 4.94773 10.2292 5.16451 10.3751 5.28276C10.3751 5.28276 12.661 7.11559 12.7097 7.155C12.8653 7.30281 12.982 7.49989 13.0112 7.73639C13.0599 8.19952 12.7389 8.63309 12.2622 8.69222C12.0385 8.72178 11.8245 8.6528 11.6689 8.5247L9.26621 6.61304C9.14949 6.52534 8.9744 6.54406 8.87712 6.66231L3.16721 14.0527C2.79757 14.5159 2.67112 15.117 2.79757 15.6984L3.52712 18.8615C3.56603 19.029 3.71194 19.1472 3.88703 19.1472L7.09703 19.1078C7.68067 19.098 8.22539 18.8319 8.59503 18.3589ZM13.0897 17.3738H18.324C18.8346 17.3738 19.25 17.7946 19.25 18.3119C19.25 18.8302 18.8346 19.25 18.324 19.25H13.0897C12.579 19.25 12.1637 18.8302 12.1637 18.3119C12.1637 17.7946 12.579 17.3738 13.0897 17.3738Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFullWhite);
export default __webpack_public_path__ + "static/media/edit-full-white.511e3175aa8398b8f4edbdccec48d280.svg";
export { ForwardRef as ReactComponent };